<template>
  <div class="vouched-container">
    <div id="vouched-element" />
  </div>
</template>
<script>
export default {
  props: [
    'token',
    'firstName',
    'lastName',
    'email',
    'phone',
  ],
  mounted() {
    if ( ($vouchedPublicKey == null) || ($vouchedCallbackUrl == null) ) {
      console.error('Missing Vouched public key or callback url')
      return
    }
    // if the user has a session opened check job.token in initialization.
    var token = null;
    if (this.token) {
      token = this.token;
    }
    // (function() {
    var vouched = Vouched({
      token: token,

      verification: {
        // verify the user's information
        firstName: this.firstName,
        lastName: this.lastName,
        // used for the crosscheck feature
        email: this.email,
        phone: this.phone
      },

      publicKey: $vouchedPublicKey,
      // enable sandbox mode
      sandbox: $vouchedSandbox,
      // your webhook for POST verification processing
      callbackURL: $vouchedCallbackUrl,
/*
      properties: [
        { name: "cleanerId", value: $cleanerId }
      ],
*/
      // mobile handoff
      crossDevice: true,
      crossDeviceQRCode: true,
      crossDeviceSMS: true,
      onInit: ({
        token,
        job
      }) => {
        console.log('initialization', job);
      },

      // callback executed after every time Job was posted
      onSubmit: ({ stage, attempts, job }) => {},

      // called when the verification is completed.
      onDone: (job) => {
        console.log('vouched is done', job)
        // Redirect to the next page based on the job success
        if (job.status == 'completed') {
          // window.location.replace("https://website.com/success/");
          this.$emit('vouched-response', { token: job.token })
        } else {
          // window.location.replace("https://website.com/failed/");
          this.$emit('vouched-response', { error: 'error' })
        }
      },
      onSurveyDone: (job) => {
        // callback when survey is submitted
      },

      // callback executed after attempt to find camera device
      onCamera: ({ hasCamera, hasPermission }) => { },

      // callback executed after DOM changes to Camera
      onCameraEvent: (cameraEvent) => { },

      // theme
      theme: {
        name: 'avant',
      },
    });
    vouched.mount("#vouched-element");
    // })();
  }
}
</script>
